"use client"

import { trpc } from "@sens/web/lib/trpc"
import { PublicAddItemForm } from "@sens/web/component/list/addItemForm"

interface PageParams {
  list: string
}

// route: /u/ira/bio-books/add
const PublicPageAdd: React.FC<{ params: PageParams }> = ({ params: { list: listIdentifier } }) => {
  // fetch list
  const list = trpc.getListPublic.useQuery(listIdentifier)

  if (!list.data) {
    return <div>Loading...</div>
  }

  return (
    <div className="container mx-auto pb-6">
      <PublicAddItemForm list={list.data} />
    </div>
  )
}

export default PublicPageAdd
